module.exports = __webpack_public_path__ + "static/media/customerFeel-happy.a70ee285.jpg";